//remove ids
$('.collapser').on("click", function() {
  $(this).next().collapse('toggle');
});

$('.collapse').on('shown.bs.collapse', function() {
  $(this).parent().find(".acc-close").removeClass("acc-close").addClass("acc-open");
  $(this).parent().find(".card-header").addClass("active");
}).on('hidden.bs.collapse', function() {
  $(this).parent().find(".acc-open").removeClass("acc-open").addClass("acc-close");
  $(this).parent().find(".card-header").removeClass("active");
});

// custom toggle
$('.c-collapser').on("click", function() {
  $(this).siblings('.collapse').collapse('toggle');
  $(this).toggleClass('open');
});